export const isIFrame = (): boolean => window !== window.parent;
